export const provinces = [
  "TP. Hồ Chí Minh",
  "Tỉnh Quảng Nam",
  "Tỉnh Phú Yên",
  "Tỉnh Quảng Trị",
  "Tỉnh Kon Tum",
];
export const districs = ["TP. Thủ Đức", "Quận 1", "Quận 2", "Quận 3", "Quận 4"];
export const wards = [
  "Phường Linh Trung",
  "Phường Trường Thọ",
  "Phường Linh Đông",
];
